var map = {
	"./components/AdModule": 208,
	"./components/AdModule/": 208,
	"./components/AdModule/index": 208,
	"./components/AdModule/index.js": 208,
	"./components/ChannelSearchBlank": 194,
	"./components/ChannelSearchBlank/": 194,
	"./components/ChannelSearchBlank/index": 194,
	"./components/ChannelSearchBlank/index.js": 194,
	"./components/ChannelSearchItem": 122,
	"./components/ChannelSearchItem/": 122,
	"./components/ChannelSearchItem/index": 122,
	"./components/ChannelSearchItem/index.js": 122,
	"./components/ChannelSearchItem/index.module": 286,
	"./components/ChannelSearchItem/index.module.scss": 286,
	"./components/ChannelSearchPopover": 124,
	"./components/ChannelSearchPopover/": 124,
	"./components/ChannelSearchPopover/index": 124,
	"./components/ChannelSearchPopover/index.js": 124,
	"./components/ChannelSearchPopover/index.module": 234,
	"./components/ChannelSearchPopover/index.module.scss": 234,
	"./components/CommodityPriceModule": 176,
	"./components/CommodityPriceModule/": 176,
	"./components/CommodityPriceModule/index": 176,
	"./components/CommodityPriceModule/index.js": 176,
	"./components/CommodityTimelineModule": 195,
	"./components/CommodityTimelineModule/": 195,
	"./components/CommodityTimelineModule/index": 195,
	"./components/CommodityTimelineModule/index.js": 195,
	"./components/ContentModule": 196,
	"./components/ContentModule/": 196,
	"./components/ContentModule/index": 196,
	"./components/ContentModule/index.js": 196,
	"./components/Contract": 146,
	"./components/Contract/": 146,
	"./components/Contract/index": 146,
	"./components/Contract/index.js": 146,
	"./components/DFPAd": 264,
	"./components/DFPAd/": 264,
	"./components/DFPAd/index": 264,
	"./components/DFPAd/index.js": 264,
	"./components/DesktopSearch": 265,
	"./components/DesktopSearch/": 265,
	"./components/DesktopSearch/index": 265,
	"./components/DesktopSearch/index.js": 265,
	"./components/EmbedModule": 197,
	"./components/EmbedModule/": 197,
	"./components/EmbedModule/index": 197,
	"./components/EmbedModule/index.js": 197,
	"./components/FeedNotice": 123,
	"./components/FeedNotice/": 123,
	"./components/FeedNotice/index": 123,
	"./components/FeedNotice/index.js": 123,
	"./components/FeedNotice/index.module": 211,
	"./components/FeedNotice/index.module.scss": 211,
	"./components/ImageModule": 198,
	"./components/ImageModule/": 198,
	"./components/ImageModule/index": 198,
	"./components/ImageModule/index.js": 198,
	"./components/NewsFeed": 204,
	"./components/NewsFeed/": 204,
	"./components/NewsFeed/index": 204,
	"./components/NewsFeed/index.js": 204,
	"./components/NewsFeedEmpty": 206,
	"./components/NewsFeedEmpty/": 206,
	"./components/NewsFeedEmpty/index": 206,
	"./components/NewsFeedEmpty/index.js": 206,
	"./components/NewsFeedLoading": 207,
	"./components/NewsFeedLoading/": 207,
	"./components/NewsFeedLoading/index": 207,
	"./components/NewsFeedLoading/index.js": 207,
	"./components/NewsItem": 205,
	"./components/NewsItem/": 205,
	"./components/NewsItem/HotIcon": 290,
	"./components/NewsItem/HotIcon.js": 290,
	"./components/NewsItem/NewsItemChannel": 292,
	"./components/NewsItem/NewsItemChannel.js": 292,
	"./components/NewsItem/NewsItemContent": 293,
	"./components/NewsItem/NewsItemContent.js": 293,
	"./components/NewsItem/NewsItemThumbnail": 294,
	"./components/NewsItem/NewsItemThumbnail.js": 294,
	"./components/NewsItem/NewsItemTimestamp": 295,
	"./components/NewsItem/NewsItemTimestamp.js": 295,
	"./components/NewsItem/ShareIcon": 291,
	"./components/NewsItem/ShareIcon.js": 291,
	"./components/NewsItem/index": 205,
	"./components/NewsItem/index.js": 205,
	"./components/NewsletterSubscription": 266,
	"./components/NewsletterSubscription/": 266,
	"./components/NewsletterSubscription/index": 266,
	"./components/NewsletterSubscription/index.js": 266,
	"./components/PriceModule": 199,
	"./components/PriceModule/": 199,
	"./components/PriceModule/ChangeDirection": 288,
	"./components/PriceModule/ChangeDirection.js": 288,
	"./components/PriceModule/Price": 287,
	"./components/PriceModule/Price.js": 287,
	"./components/PriceModule/PriceLoading": 289,
	"./components/PriceModule/PriceLoading.js": 289,
	"./components/PriceModule/index": 199,
	"./components/PriceModule/index.js": 199,
	"./components/RotatingContentModule": 201,
	"./components/RotatingContentModule/": 201,
	"./components/RotatingContentModule/index": 201,
	"./components/RotatingContentModule/index.js": 201,
	"./components/TextModule": 202,
	"./components/TextModule/": 202,
	"./components/TextModule/index": 202,
	"./components/TextModule/index.js": 202,
	"./components/VideoModule": 203,
	"./components/VideoModule/": 203,
	"./components/VideoModule/index": 203,
	"./components/VideoModule/index.js": 203,
	"./containers/NewsFeedContainer": 267,
	"./containers/NewsFeedContainer/": 267,
	"./containers/NewsFeedContainer/index": 267,
	"./containers/NewsFeedContainer/index.js": 267,
	"./containers/PriceContainer": 200,
	"./containers/PriceContainer/": 200,
	"./containers/PriceContainer/index": 200,
	"./containers/PriceContainer/index.js": 200,
	"./controllers/channel_header_controller": 395,
	"./controllers/channel_header_controller.js": 395,
	"./controllers/content_modules/commodity_price_controller": 396,
	"./controllers/content_modules/commodity_price_controller.js": 396,
	"./controllers/content_modules/commodity_timeline_controller": 397,
	"./controllers/content_modules/commodity_timeline_controller.js": 397,
	"./controllers/content_modules/rotating_content_module_controller": 398,
	"./controllers/content_modules/rotating_content_module_controller.js": 398,
	"./controllers/focus_modal_controller": 399,
	"./controllers/focus_modal_controller.js": 399,
	"./controllers/follow_controller": 400,
	"./controllers/follow_controller.js": 400,
	"./controllers/futures_controller": 401,
	"./controllers/futures_controller.js": 401,
	"./controllers/fuzzy_timestamp_controller": 402,
	"./controllers/fuzzy_timestamp_controller.js": 402,
	"./controllers/horizontal_scroll_controller": 403,
	"./controllers/horizontal_scroll_controller.js": 403,
	"./controllers/market_reports_controller": 404,
	"./controllers/market_reports_controller.js": 404,
	"./controllers/news_ticker_controller": 405,
	"./controllers/news_ticker_controller.js": 405,
	"./controllers/real_time_prices_controller": 406,
	"./controllers/real_time_prices_controller.js": 406,
	"./controllers/real_time_prices_feeder_cattle_controller": 407,
	"./controllers/real_time_prices_feeder_cattle_controller.js": 407,
	"./controllers/share_controller": 408,
	"./controllers/share_controller.js": 408,
	"./controllers/static_content_controller": 409,
	"./controllers/static_content_controller.js": 409,
	"./controllers/table_sorting_controller": 410,
	"./controllers/table_sorting_controller.js": 410,
	"./controllers/toast_controller": 411,
	"./controllers/toast_controller.js": 411,
	"./controllers/vertical_carousel_controller": 414,
	"./controllers/vertical_carousel_controller.js": 414,
	"./controllers/video_play_controller": 412,
	"./controllers/video_play_controller.js": 412,
	"./controllers/weightboard_controller": 413,
	"./controllers/weightboard_controller.js": 413,
	"./images/default_thumbnail": 297,
	"./images/default_thumbnail.png": 297,
	"./models/news_item": 126,
	"./models/news_item.js": 126,
	"./utils/objectHash": 296,
	"./utils/objectHash.js": 296
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 898;